import { moduleProviderFactory } from "core/providers";
import { FacilityOrderTemplateNewFlowPatientCreate } from "application/facility-order-new-flow/pages";
import { FacilityOrderNewFlowUSIntakePreview } from "application/facility-order-new-flow-us-intake/pages";
import { InventoryRequestEmailEdit } from "application/inventory-request/pages";

(function () {
    moduleProviderFactory.application.register({
        routes: [
            {
                name: "master.app.main.facility-order",
				pattern: "/facility-orders",
                children: [
					{
						name: "master.app.main.facility-order.facility-order-new-flow.us-intake-preview",
						pattern: "/:id/new-flow/us-intake",
						authorization: "facilityOrderSection.update",
						component: FacilityOrderNewFlowUSIntakePreview,
						data: {
							//title: "",
							crumbs: [
								{
									title: "FACILITY_ORDER.CRUMB.US_INTAKE",
									route: 'master.app.main.facility-order.facility-order-new-flow.us-intake-preview'
								}
							],
							back: "master.app.main.facility-order.facility-order-new-flow.list",
						},
					},
					{
						name: "master.app.main.facility-order.facility-order-new-flow.us-intake-create-patient",
						pattern: "/:id/new-flow/us-intake/create-patient",
						authorization: "facilityOrderSection.create",
						tabTitle: 'Create New Patient',
						component: FacilityOrderTemplateNewFlowPatientCreate,
						data: {
							crumbs: [
								{
									title: "FACILITY_ORDER.CRUMB.US_INTAKE",
									route: 'master.app.main.facility-order.facility-order-new-flow.us-intake-preview'
								},
								{
									title: "FACILITY_ORDER.CRUMB.CREATE_NEW_PATIENT",
									route: 'master.app.main.facility-order.facility-order-new-flow.us-intake-create-patient'
								}
							],
							back: "master.app.main.facility-order.facility-order-new-flow.us-intake-preview",
						},
					},
					{
						name: "master.app.main.facility-order.inventory-request.new-flow-edit-email",
						pattern: "/:facilityOrderId/:inventoryRequestType/new-flow/inventory-request",
						component: InventoryRequestEmailEdit,
						data: {
							crumbs: [
								{
                                    title: "FACILITY_ORDER.CRUMB.US_INTAKE",
									route: 'master.app.main.facility-order.facility-order-new-flow.us-intake-preview'
                                },
                                {
                                    title: "Inventory Request",
                                    route: 'master.app.main.facility-order.inventory-request.new-flow-edit-email'
                                }
							]
						}
					},					
                ]
            }
        ],
		menu: [
            {
				title: "MENU.FACILITY_ORDERS",
				icon: "package",
				authorization: "coreUserSection.read",
				order: 5,
				subMenu: [
					{
						title: "MENU.FACILITY_ORDERS_SUB",
						authorization: "facilityOrderSection.read",
						route: "master.app.main.facility-order.facility-order-new-flow.list",
						order: 2,
					}
				]
			},
        ]
    });
})();
